import { Input } from './lib/input.js';
// @ts-ignore TODO fix typings, probably Mixin related
customElements.define('cipublic-input', Input);
//# sourceMappingURL=cipublic-input.js.map